import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            {featuresData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-500">{featuresData.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {featuresData.items.map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-xl p-6 border border-background-200/60 hover:border-primary-200/60 transition-colors duration-200"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-800 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}